<template>
  <div class="gp-content">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'AlertsSection',
  computed: {
    tabs() {
      return [
        {
          label: 'Alerts',
          link: {
            name: 'alerts.index',
          },
          icon: 'alerts',
        },
      ];
    },
  },
  mounted() {
    this.SET_SECTION('Alerts');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>

<style lang="scss" scoped>

</style>
